export default {
    checkInOutApproval: 'Check In / Out Approval',
    firstLastName: 'First Name and Last Name',
    requestType: 'Request Type',
    startDate: 'Start Date',
    forgetDate: 'Forget Date',
    pending: 'Pending',
    processed: 'Processed',
    checkInTime: 'Check In Time',
    checkOutTime: 'Check Out Time',
    description: 'Description',
    back: 'Back',
    reject: 'Reject',
    approve: 'Approve',
    cannotGetLineId: 'Cannot get line user id'
}
